parseTokenMMDD